export default {
  oAuth2TokenCookieName: 'OAuth2TokenStage',
  personalizationApi: {
    space: 'a4nvg3fdk34l',
    accessToken: 'a82b62d5bbd54f0544978b3d01475645750ac58ae3f80e52703a541d0530bc9c',
    host: window.location.hostname,
    basePath: 'personalization-api/v3',
    environment: 'master'
  },
  authorizationProxy: {
    url: 'https://proxy.stage.digital.telus.com/oauth2-preprod'
  }
}
